import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthenticationService } from "@auth/authentication.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const currentUser = this.authenticationService.currentUserValue;
      if (currentUser) return true;

      return this.logout(state.url);
    } catch (error) {
      return this.logout(state.url);
    }
  }

  logout(url?: string): boolean {
    if (url) {
      this.router.navigate(["/login"], {
        queryParams: {
          returnUrl: url,
        },
      });
    } else {
      this.router.navigate(["/login"]);
    }

    return false;
  }
}
